import { uxReducerPath } from './const';
import { UXSliceShape } from './types';

export const loginShownSelector = (state: UXSliceShape) => state[uxReducerPath].loginShown;

export const needHelpShownForGuestSelector = (state: UXSliceShape) => state[uxReducerPath].needHelpShownForGuest;

export const needHelpShownForRegisteredUserSelector = (state: UXSliceShape) => state[uxReducerPath].needHelpShownForRegisteredUser;

export const notificationsSubscribeReminderLastShownInMsSelector = (state: UXSliceShape) =>
  state[uxReducerPath].notificationsSubscribeReminderLastShownInMs;
